import React, { useEffect, useState } from 'react'
import DateConverter from '../Tools/DateConverter'
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;

function FreidoraInfo(props) {
    const { infor, sucursal, idEmpleado, tipoF } = props;
    const [ultimosEventos, setUltimosEventos] = useState([]);
    const [ultimosEventosTms, setUltimosEventosTms] = useState([]);
    const [numDias, setNumDias] = useState(0);
    const [procesos, setProcesos] = useState([]);
    const [ultimoTms, setUltimoTms] = useState({});
    function getColor(tipo) {
        if (tipo == 'A') {
            return 'fondoMostasa'
        } else if (tipo == 'T') {
            return 'fondoGuindo'
        } else if (tipo == 'L') {
            return 'fondoVerdeOscuro'
        } else if (tipo == 'S') {
            return 'fondoVioleta'
        } else {
            return ''
        }
    }
    function getColorLetra(valor) {
        if (valor < 4) {
            return 'colorVerde'
        } else {
            return 'colorRojo'
        }
    }
    function getTiempoEstimado() {
        try {
            var fecha = new Date(ultimoTms.FECHA);
            var tpm = parseFloat(ultimoTms.DESCRIPCION.split(':')[1]);
            for (var i = 0; i < 30; i++) {
                if (tpm < 25) {
                    var numdi = fecha.getDay();
                    if (numdi >= 1 && numdi <= 4) {
                        tpm += 1
                    } else {
                        tpm += 1.5
                    }
                    fecha.setDate(fecha.getDate() + 1);
                } else {
                    break;
                }
            }
            var fechah = new Date();
            var tiempo = fecha.getTime() - fechah.getTime();
            tiempo = parseInt(tiempo / (1000 * 60 * 60 * 24));
            if (tiempo <= 0) {
                return 'Hoy'
            } else {
                return tiempo + ' Dias'
            }
        } catch (error) {
            return '?'
        }
    }
    function getNumDias() {
        try {
            var aux = infor.RESPUESTA.filter((item) => item.DESCRIPCION.indexOf('Cambio') != -1);
            var fechaHoy = new Date();
            var fechaUlt = new Date(aux[0].FECHA);
            var dias = (fechaHoy.getTime() - fechaUlt.getTime()) / (1000 * 60 * 60 * 24);
            setUltimoTms(infor.RESPUESTA.filter(item => item.DESCRIPCION.indexOf('TPM') != -1)[0])
            setNumDias(parseInt(dias));
            //getProcFreidora(aux[0]);
        } catch (error) {
            setNumDias(0);
        }
    }
    useEffect(() => {
        var ult = infor.RESPUESTA.slice(0, 5);
        setUltimosEventos(infor.RESPUESTA.filter((item) => item.TIPO_EVENTO !== 'T'));
        setUltimosEventosTms(infor.RESPUESTA.filter((item) => item.TIPO_EVENTO == 'T'));
        getNumDias()
    }, [infor])
    return (
        <>
            <div className='bg-dark bg-gradient text-light'>
                <div className={`text-center fw-bold ${getColorLetra(infor.DIACAMBIO)}`} style={{ fontSize: '24px' }}>{infor.DIACAMBIO}</div>
                <div className='text-center' style={{ fontSize: '12px' }}>días en esta freidora</div>
                <hr className='m-1' style={{ color: '#ffffff' }}></hr>

                <div className='text-center'>Procesos : {infor.CANT}</div>
                {tipoF == 'Pollo' && <div className='text-center'>Octavos : {(infor.CANT1 + infor.CANT2)*2}</div>}
                {tipoF == 'Pollo' && <div className='text-center'>Pipocas : {infor.CANT4}</div>}
                {tipoF == 'Papa' && <div className='text-center'>Porciones : {infor.CANT1}</div>}

                {procesos.length == 0 && false && <>
                    <div className='text-center'>Procesos : ?</div>
                    {tipoF == 'Pollo' && <div className='text-center'>Octavos : ?</div>}
                    {tipoF == 'Pollo' && <div className='text-center'>Pipocas : ?</div>}
                    {tipoF == 'Papa' && <div className='text-center'>Porciones : ?</div>}
                </>}
                <hr className='m-1' style={{ color: '#ffffff' }}></hr>
                <div className='text-center fw-bold'>Cambio estimado: {getTiempoEstimado()}</div>
            </div>
            <div className='bg-secondary bg-gradient'>
                <ul className="list-group">
                    {ultimosEventosTms.map((item, index) => {
                        if (index <= 3) {
                            return (
                                <li className={`list-group-item bordeNegro text-center text-light m-0 p-0 ${getColor(item.TIPO_EVENTO)}`} key={index}>
                                    <div className='fw-bold'>{item.DESCRIPCION}
                                    </div>
                                    <div style={{ fontSize: '11px' }}>
                                        {DateConverter.formatoFechaCorto(new Date(item.FECHA)) + ' ' + DateConverter.formatoHora(item.FECHA)}
                                    </div>
                                </li>
                            )
                        }
                    })}
                </ul>
                <ul className="list-group">
                    {ultimosEventos.map((item, index) => {
                        if (index <= 3) {
                            return (
                                <li className={`list-group-item bordeNegro text-center text-light m-0 p-0 ${getColor(item.TIPO_EVENTO)}`} key={index}>
                                    <div className='fw-bold'>{item.DESCRIPCION}
                                    </div>
                                    <div style={{ fontSize: '11px' }}>
                                        {DateConverter.formatoFechaCorto(new Date(item.FECHA)) + ' ' + DateConverter.formatoHora(item.FECHA)}
                                    </div>
                                </li>
                            )
                        }
                    })}
                </ul>
            </div>
        </>
    )
}

export default FreidoraInfo